<template>
  <div>
    <wx-open-launch-app
      :id="id"
      class="launch-btn"
      :appid="appId"
      :extinfo="extinfoStr"
    >
      <script type="text/wxtag-template">
        <style>.btn {height: 96px;}</style>
        <div class="btn">打开app</div>
      </script>
    </wx-open-launch-app>
    <div class="content-copy" v-show="false">{{extinfoStr}}</div>
  </div>
</template>
<script>

import Clipboard from 'clipboard'

let idIndex = 0
export default {
  name: 'WechatOpenApp',
  props: {
    extinfo: {
      type: Object,
    },
  },
  watch: {
    extinfo: {
      handler(n){
        this.extinfoStr = JSON.stringify(n)
      },
      immediate: true
    }
  },
  data() {
    idIndex++
    return {
      id: 'wxopenLanchAppId' + idIndex,
      appId: process.env.VUE_APP_WONDERCV_APP_ID,
      enable: false,
      extinfoStr: '',
    }
  },
  methods: {
    redirectToApp(){
      setTimeout(()=>{
        window.location.href = 'https://sj.qq.com/myapp/detail.htm?apkName=com.wondercv'
      }, 400)
    },
    setClipboard(){
      console.log('start copy')
      let copyObject = {
        app: 'wondercv'
      }
      for(var k in this.extinfo){
        copyObject[k] = this.extinfo[k]
      }
      copyObject = JSON.stringify(copyObject)

      let clipboard = new Clipboard('.content-copy')
      clipboard.on('success', e => {
        clipboard.destroy() // 释放内存
      })
      console.log('end copy')
    },
    launch(){
      this.setClipboard()
      // alert("点击了按钮")
      if(!this.enable){
        console.log('版本太低')
        alert('版本太低')
        // this.redirectToApp()
      }
    },
    getWeixinVersion() {
      let wechatInfo = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i) ;
      return wechatInfo[1]
    }
  },
  created(){
    // 微信版本号大于 7.0.12 开放标签才可进行 唤醒 app 跳转
    const wxVersion = this.getWeixinVersion()
    console.log(wxVersion,"=====>微信版本")
    alert(wxVersion+"=====>微信版本")
    if(wxVersion){
      let v = wxVersion.split('.')
      if(v[0] == 7){
        if(v[1] >= 0){
          if(v[2] >= 12){
            this.enable = true
          }
        }
      } else if (v[0] > 7) {
        this.enable = true
      }
    }
  },
  mounted(){
    var btn = document.getElementById(this.id)
    console.log(btn,"=====>btn")
    btn.addEventListener('click', e => {
      this.launch()
    });
    btn.addEventListener('launch', e => {
      this.setClipboard()
      console.log('success');
      // alert('success')
      // alert(this.extinfoStr)
    });
    btn.addEventListener('error',  e => {
      console.log('fail', e.detail);
      alert(JSON.stringify(e.detail));
      this.setClipboard()
      // this.redirectToApp()
    });
  }
}
</script>
<style lang="scss" scoped>
.launch-btn{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
  //opacity: 0;
  background: red;
}
</style>
